import type { TemplateBlocksSectionProps } from '~/components/TemplateBlocksSection/TemplateBlocksSection';
import type { StatusByTemplateStepId } from '~/components/TouchCampaignGraph/touchGraphLayout';
import { TouchCampaignGraph } from '~/components/TouchCampaignGraph/TouchCampaignGraph';

type Props = {
  /** Shared editor wiring (documents / reminders / sift / @-variables). */
  editorContext: Omit<TemplateBlocksSectionProps, 'cadenceTemplate'>;
  cadenceTemplate: TemplateBlocksSectionProps['cadenceTemplate'];
  /**
   * This contact's per-step status keyed by template step id — overlays done /
   * action-needed / errored / skipped on the graph. This panel is the contact-only
   * entry point, so status lives here (never on the standalone template page).
   */
  contactStepStatuses?: StatusByTemplateStepId | null;
  /** Complete an action-required step for this contact (its own cadence-step id). */
  onMarkStepFinished?: (cadenceStepId: string) => void;
};

/**
 * Touch campaign graph on the contact detail Interact tab. Always the same
 * draggable, branching node-canvas (dotted background, edges, pan) the template
 * page uses. The Minimal / Expanded toggle (mirroring the campaign switch) only
 * changes each touch's node density — compact icon chips vs the full card — so
 * branches (No branch, fork arms) stay visible in BOTH modes. Starts in Minimal
 * so the graph keeps a small footprint. Wheel scrolls the page (drag to pan).
 */
export function ContactTouchGraphPanel({
  editorContext,
  cadenceTemplate,
  contactStepStatuses,
  onMarkStepFinished,
}: Props) {
  return (
    <div className="relative h-[70vh] min-h-[420px] w-full overflow-hidden rounded-lg border border-lynch-200 dark:border-slate-700">
      <TouchCampaignGraph
        {...editorContext}
        cadenceTemplate={cadenceTemplate}
        contactStepStatuses={contactStepStatuses}
        onMarkStepFinished={onMarkStepFinished}
        hideCandidates
        disableWheelPan
        showViewToggle
        defaultMinimal
      />
    </div>
  );
}
